import React, { useEffect } from 'react';
import { MyDashBoardProps } from "./MyDashBoard.props";
import { Grid } from "@mui/material";
import Box from '@mui/material/Box';
import { MyProfile } from "../../components/MyProfile/MyProfile";
import ActivityTimeline from "../../components/ActivityTimeline/ActivityTimeline";
import Badges from '../../components/Badges/Badges';
import EmailContentType from '../../components/EmailContentType/EmailContentType';
import { ContentHistory } from "../../components/ContentHistory/ContentHistory";
import { useDispatch } from "react-redux";
import { getBadgeAchievementsEvents, getBadgeAchievementsEventsDataSelector } from "../../redux/getBadgeAchievementSlice";
import { useAppSelector } from "../../redux/hooks";
import { workSpaceEventsDataSelector } from "../../redux/workSpaceSlice";
import { LoadingPage } from "../../components/LoadingPage";
import { HAS_VALUES } from "../../constants/constants";
import { getBadgesEvents, getBadgesEventsDataSelector, resetBadgesEvents } from "../../redux/getBadgeSlice";
import { getCurrentCellStore } from '../../utils/util';
import {getProfilesEvents } from "../../redux/getProfileSlice";

const MyDashBoard: React.FC<MyDashBoardProps> = () => {
  const dispatch = useDispatch<any>();
  const { badgeAchievementsData, isLoading } = useAppSelector(getBadgeAchievementsEventsDataSelector);
  const { workSpaceCurrentData } = useAppSelector(workSpaceEventsDataSelector);
  const { badgesData, isLoading: loadingBadge } = useAppSelector(getBadgesEventsDataSelector);
  const userCurrentCellStore = getCurrentCellStore();
  const [isAchievementPopupOpen, setIsAchievementPopupOpen] = React.useState(false);
  const { profileData, isLoading: isLoadingMyprofile  } = useAppSelector(
    (state) => state.profilesEvents
  );

  const defaultValue =(emails:string, courses:string)=>{
    let result = '';
    if(userCurrentCellStore?.show_training_data && userCurrentCellStore?.show_phishing_data) {
      result = `${emails} and ${courses}.`
    }else if(userCurrentCellStore?.show_phishing_data) {
      result = `${emails}.`
    } else if(userCurrentCellStore?.show_training_data) {
      result = `${courses}.`
    } else {
      result = '';
    }
    return result;
  }

  useEffect(() => {
    dispatch(getBadgeAchievementsEvents({}));
    dispatch(getBadgesEvents({}));
    const defaultValueResult = defaultValue('emails', 'courses');
    if (defaultValueResult) {
      const param = defaultValueResult === "emails and courses." ? 'full' : (defaultValueResult === 'emails.' ? 'email' : 'courses');
      dispatch(getProfilesEvents({type: param}));
    }
    return () => {
      dispatch(resetBadgesEvents());
    };
  }, [workSpaceCurrentData])

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={'20px'}>
          <Grid item >
            <Box width="400px" bgcolor="white">
              <MyProfile profileData = {profileData} />
            </Box>
          </Grid>
          <Grid item xs sm md lg xl style={{ overflow: 'hidden' }}>
            {badgeAchievementsData?.has_achievement === HAS_VALUES.TRUE ? <Box bgcolor="white" mb={'20px'} >
              <Badges 
                data={badgesData ?? {}} 
                onOpenAchievementChange={setIsAchievementPopupOpen}
              />
            </Box> : null}
            {userCurrentCellStore?.show_phishing_data && (
              <Box bgcolor="white" mb={'20px'}>
                <EmailContentType data={badgeAchievementsData?.email_content_type ?? {}} />
              </Box>
            )}
            <Box bgcolor="white" mb={'20px'}>
              <ActivityTimeline text = {`Timeline of your ${defaultValue('phishing reports','training activity')}`} data={badgeAchievementsData?.timeline_summary ?? {}} />
            </Box>
            <Box bgcolor="white" mb={'20px'}>
              <ContentHistory text = {`Your past ${defaultValue('phishing simulations','training activity')}`} data={badgeAchievementsData?.content_histories} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <LoadingPage open={!isAchievementPopupOpen && (isLoading || loadingBadge || isLoadingMyprofile)} />
    </>
  );
};

export default MyDashBoard;